import {
  LoadingController,
  AlertController,
  ToastController,
} from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { TrackingService } from '../services/tracking.service';

export class BasePage {
  constructor(
    protected loadingController: LoadingController,
    protected alertController: AlertController,
    protected toastController: ToastController,
    protected route: ActivatedRoute,
    protected track: TrackingService
  ) {}

  async showError(message = 'An error occurred'): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Error',
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async showToast(
    message: string,
    duration = 3000,
    position?: 'top' | 'bottom' | 'middle'
  ) {
    const toast = await this.toastController.create({
      message,
      duration,
      position: position || 'top',
    });
    return await toast.present();
  }
}
